/**
 * Records a reload attempt for an image that failed to load (e.g. an expired
 * signed URL). Returns true the first time it is called for an image id, and
 * false afterwards, so each image triggers at most one refetch. This prevents
 * an endless error -> refetch -> same URL -> error loop.
 */
export function shouldRetryImageLoad(
  retriedImageIds: Set<number>,
  imageId: number,
): boolean {
  if (retriedImageIds.has(imageId)) return false;
  retriedImageIds.add(imageId);
  return true;
}
